import { Box, Skeleton, Typography } from "@mui/material"
import { checkResultValue, LoadingTestCase, TestCaseComponent } from "./TestCaseComponent"
import { memo, useCallback, useEffect, useRef, useState } from "react"
import { DeviceService } from "../../services/DataService"
import TimeUtils from "../../utils/TimeUtils"
import { translate, Translate } from "react-i18nify"
import { ConfirmDialog, DIALOGTYPE } from "../Layout/Dialog/ConfirmDialog"
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ConstructionIcon from "@mui/icons-material/Construction";
import { LoadingButton } from "@mui/lab"
import AlertBox from "../AlertBox"
import { METADATANAMES, TESTMETADATATYPES, TestMetaData } from "./TestMetaData"
import { DEVICE_TYPE } from "../../pages/Production/Production"

export const TestCasesContainer = memo( function TestCasesContainer({ testProtocol, udsn, setConfirmRedirect, deviceType}){
   
    const [testCases, setTestCases] = useState([])
    const [testResults, setTestResults] = useState([])
    const [showNotValidTestPopUp, setShowNotValidTestPopUp] = useState(false)
    const [notValidTestPopUpText, setNotValidTestPopUpText] = useState({
        "metadataText": "",
        "testValidText": "",
        "testEquipmentText": ""
    })
    const [metadataNotValid, setMetadataNotValid] = useState(false)
    const [submitLoading, setSubmitLoading] = useState(false)
    const [puid, setPuid] = useState(defaultMetadata)
    const [mac, setMac] = useState(defaultMetadata)
    const [swfw, setSwfw] = useState({sw: [], fw: []})
    const [selectedSwFw, setSelectedSwFw] = useState({sw: defaultMetadata, fw: defaultMetadata})
    const equipment = useRef([])

    const [alertBox, setAlertBox] = useState({
        "visiblity": false,
        "statusCode": null,
        "text": null,
        "error": null
    })

    const isHotDevice = deviceType === DEVICE_TYPE.HOT.code;

    useEffect(() => {
        (async () => {
            const mdNameArray = [
                isHotDevice ? METADATANAMES.HOT_SW : METADATANAMES.SW,
                isHotDevice ? METADATANAMES.HOT_FW : METADATANAMES.FW,
                isHotDevice ? METADATANAMES.PUID :  METADATANAMES.SN, 
                isHotDevice ? METADATANAMES.MAC : ""
            ]
            DeviceService.getByNames(mdNameArray.join(), true, udsn)
            .then(res => {
                let sw = []
                let fw = []
                let puid
                let mac
                res.data.map(g => {
                    const metadataName = g[0].name.toLowerCase();
                    if(metadataName === (isHotDevice ? METADATANAMES.HOT_SW.toLowerCase() : METADATANAMES.SW.toLowerCase())){
                        sw = g
                    }else if(metadataName === (isHotDevice ? METADATANAMES.HOT_FW.toLowerCase() : METADATANAMES.FW.toLowerCase())){
                        fw = g
                    }
                    else if(metadataName === (isHotDevice ? METADATANAMES.PUID.toLowerCase() : METADATANAMES.SN.toLowerCase())){
                        puid = g[0]
                    }else if(isHotDevice && metadataName === METADATANAMES.MAC.toLowerCase()){
                        mac = g[0]
                    }
                })
                setPuid(puid)
                setMac(mac)
                setSwfw({"sw": sw, "fw": fw})
            }).catch(e => {
                console.error(e)
            });
        })();        
    },[])

    
    useEffect(() => {
        const numberOfTestCases = parseInt(testProtocol?.metadata.testCases)
        let defaultTestCases = []
        for(let i = 1; i < numberOfTestCases + 1; i++){
            defaultTestCases.push({
                caseId: i, 
                passed: null, 
                resultValue: {
                    value: null
                }, 
                comment: "" 
            })
        }
        setTestCases(defaultTestCases);
        setTestResults(defaultTestCases);

        const numberOfEquipment = parseInt(testProtocol?.metadata?.testEquipmentCount)
        if(equipment.current.length != numberOfEquipment){
            for(let i = 0; i < numberOfEquipment; i++){
                equipment.current.push({type: TESTMETADATATYPES.EQUIPMENT, typeId: "", id: "", required: true})
            }
        }
    },[testProtocol])

    const checkComments = (testResults) => {
        return testResults.testCases.filter(tr => tr.passed === false && tr.comment === "").length <= 0
    }

    const checkResultValues = (testResults) => {
        return testResults.testCases.filter(tr => tr.passed === true && checkResultValue(tr.resultValue.value)).length <= 0
    }

    const checkNullable = (testResults) => {
        return testResults.filter(v => v.passed === null).length > 0
    }

    const checkPassed = (testResults) => {
        return testResults.filter(v => v.passed !== true).length <= 0 && !checkNullable(testResults)
    }

    //Returns true if required equipment is present
    const checkEquipment = (equipment) => {
        return equipment?.filter(e => e.required === true && ( e.typeId === "" || e.id === "")) <= 0
    }

    const prepareBody = () => {
        return {
            "testResult": {
                "testProtocol": testProtocol.fileName,
                "passed": metadataNotValid === true ? false : checkPassed(testResults), //return every test case that has failed, so if the length is more than 0 that means some test have failed
                "udsn": udsn,
                "submitUnixTimestamp": TimeUtils.dateToUTC(new Date()),
                "testCases": testResults,
                "equipmentMetadata": equipment.current
            },
            "metaDataValues": isHotDevice ? [mac, puid, selectedSwFw.sw, selectedSwFw.fw] : [puid, selectedSwFw.sw, selectedSwFw.fw],
        }
    }

    const handleSubmit = () => {
        try{
            setSubmitLoading(true)
            const body = prepareBody();
            const isEquipmentValid = checkEquipment(equipment.current)
            if(!checkResultValues(body.testResult) || !checkComments(body.testResult) || !isEquipmentValid){
                handleAlertBox(true, 400, "Please fill required fields")
                setSubmitLoading(false)
            }else if(!body.testResult.passed || metadataNotValid){
                setNotValidTestPopUpText({
                    metadataText: metadataNotValid ? "MetadataNotFilled" : "",
                    testValidText: !body.testResult.passed ? checkNullable(testResults) ?  "DeviceWillBeMovedToRepairNullTests" : "DeviceWillBeMovedToRepair" : "",
                    testEquipmentText: !isEquipmentValid ? "EquipmentInfoNotVaild" : "" 
                })
                setShowNotValidTestPopUp(true)
            }else{
                submitTestResult(body)
            }
        }catch(e){
            console.error(e)
        }
    }

    const submitTestResult = (body) => {
        DeviceService.saveTestResult(body).then(res => {
            handleAlertBox(true, res.status, res.data, null)
            setTimeout(() => {
                setConfirmRedirect(true)
            }, 4000);
        }).catch(e => {
            console.error(e)
            try{
                handleAlertBox(true, e.response.status, e?.response?.data?.detail ?? e?.response?.data, null)

            }catch(e){
                handleAlertBox(true, e.response.status, null, null)
            }
        }).then(() => {
            setSubmitLoading(false)
        })
    }

    const checkMetadataErrors = (puidResult, macResult, swFwResult) => {
        setMetadataNotValid(puidResult || macResult || swFwResult.swActive || swFwResult.fwActive)
    }

    const dismissAlertBox = () => {
        setAlertBox({
            "visiblity": false,
            "statusCode": null,
            "text": null,
            "error": null
        })
    }
    
    const handleAlertBox = (visiblity, statusCode, text, error) => {
        setAlertBox({
            "visiblity": visiblity,
            "statusCode": statusCode,
            "text": text,
            "error": error
        })
    }

    return(
        <Box id="TestCaseGroup"  >
            <Box sx={{ width:"100%" }} >
                {
                    swfw.sw.length !== 0 && swfw.fw.length !== 0 ?
                    <TestMetaData 
                        deviceType={deviceType} 
                        puid={puid}
                        setPuid={setPuid}
                        mac={mac}
                        setMac={setMac}
                        swfw={swfw} 
                        selectedSwFw={selectedSwFw}  
                        setSelectedSwFw={setSelectedSwFw}
                        equipment={equipment}
                        checkMetadataErrors={checkMetadataErrors}  
                    />
                    :
                    <Skeleton animation="pulse" variant="rounded" height={320} width={"80%"} sx={{ mt: 1}}> 
                        <TestMetaData/>
                    </Skeleton>
                }
            </Box>
            <Box id="TestCases" >
            { 
                testCases?.length >= 1 ? 
                    testCases?.map((val,key) => {
                        return(
                            <Box  id="SingleTestCase" sx={{mb:2, width: {sm:550, md:550, lg:750 } }} >
                                <TestCaseComponent
                                id={key}
                                defaultCaseObject={val}
                                setTestResults={setTestResults}
                                />
                            </Box>
                        )
                    })
                : 
                    <LoadingTestCase/>
            }
            </Box>
            <ConfirmDialog
                dialogIcon={<ErrorOutlineIcon color="error" sx={{ fontSize: 75 }} />}
                title={<Translate value="PleaseConfirm" />}
                declineText={<Translate value="Close" />}
                confirmText={<Translate value="Continue" />}
                confirmButtonIcon={<ConstructionIcon />}
                rejectButtonVariant="primary"
                open={showNotValidTestPopUp}
                onClose={() => {
                    setShowNotValidTestPopUp(false);
                    setSubmitLoading(false);
                }}
                onConfirm={() => {
                    setShowNotValidTestPopUp(false);
                    submitTestResult(prepareBody())
                }}
            >
                <DeviceTestDialogContent
                    message={notValidTestPopUpText}
                />                
            </ConfirmDialog>
            <Box id="Submit">
                {
                    alertBox.visiblity ===  true ?
                        <AlertBox
                            visible={alertBox.visiblity}
                            text={alertBox.text}
                            error={alertBox.error}
                            statusCode={alertBox.statusCode}
                            onHide={dismissAlertBox}
                            duration={2000}
                        />
                    :
                        <LoadingButton
                            sx={{ mt: 2, alignSelf: "flex-start" }}
                            type="submit"
                            variant="contained"
                            loading={submitLoading}
                            loadingPosition="center"
                            onClick={handleSubmit}
                            >
                                <Translate value="Submit" />{" "}
                        </LoadingButton>            
                }
            </Box>
        </Box>
    )
})
export const defaultMetadata = {value: "", metadataId: 0, id:0}

const DeviceTestDialogContent = (props) => {
    return(
      <>
        <Box>
            {
            props.message.testValidText !== "" ? 
            <Typography sx={{ width: "100%", textAlign: "center" }} component="div" variant="body1">
                {translate(props.message.testValidText)}
            </Typography>
            :
            <></>
            }
        </Box>
        <Box>
            {
                props.message.metadataText !== "" ? 
                <Typography sx={{ width: "100%", textAlign: "center", mt:1 }} component="div" variant="body1">
                    {translate(props.message.metadataText)}
                </Typography>
                :
                <></>
            }
        </Box>
        <Box>
            {
                props.message.testEquipmentText !== "" ? 
                <Typography sx={{ width: "100%", textAlign: "center", mt:1 }} component="div" variant="body1">
                    {translate(props.message.testEquipmentText)}
                </Typography>
                :
                <></>
            }
        </Box>
        <Box>
            <Typography sx={{ width: "100%", textAlign: "center", mt:1 }} component="div" variant="body1">
                <b>{translate("DeviceToRepair")}</b>
            </Typography>
        </Box>
    </>
  )
}

